export default "__VITE_ASSET__AMZM2hTR__"